module.exports = __webpack_public_path__ + "ak.no1.6db3e886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ak.no1.jpg
// module id = sWm/
// module chunks = 0